import { render, staticRenderFns } from "./PeriodSpendingsItem.vue?vue&type=template&id=27e51a6b&"
import script from "./PeriodSpendingsItem.vue?vue&type=script&lang=js&"
export * from "./PeriodSpendingsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports